/**
 * 名前空間 `shell` — 管理画面の枠 (ヘッダー・サイドバー・通知ドロワーの枠・個人設定・権限確認・エラー境界)。
 * 文言は `locales/ja/shell.ts` (正本) と `locales/en/shell.ts`。画面は `useT(shellNs)`。
 */
import { defineNamespace } from '../registry';
import { shellEn } from '../locales/en/shell';
import { shellJa } from '../locales/ja/shell';

export const shellNs = defineNamespace('shell', shellJa, shellEn);
